@if (initialized) {
    @if (importRecordData) {
        <ng-container *ngIf="importId">
            <mvs-im-view-import [importId]="importId"></mvs-im-view-import>
        </ng-container>
<!--        <mvs-widget-->
<!--                [widgetData]="importRecordData"-->
<!--        ></mvs-widget>-->
    }
}
